function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#help_svg__clip0)",
  fill: "#CDD2D9"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.167 12a.667.667 0 11-1.334 0 .667.667 0 011.334 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.5 16c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm0-15c-3.86 0-7 3.14-7 7s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.5 9.833a.5.5 0 01-.5-.5V8.66c0-.635.403-1.203 1.001-1.415.797-.28 1.332-1.129 1.332-1.745A1.835 1.835 0 008.5 3.667 1.835 1.835 0 006.667 5.5a.5.5 0 01-1 0A2.837 2.837 0 018.5 2.667 2.837 2.837 0 0111.333 5.5c0 1.112-.878 2.293-1.999 2.689A.5.5 0 009 8.66v.672a.5.5 0 01-.5.5z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "help_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.5)",
  d: "M0 0h16v16H0z"
})));

function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgHelp;